var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgO(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "c29728f7-07f1-4bc0-a5f9-f5521134cb2d"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(61.01 0 0 61.01 541.02 539.18)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 0.5,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "evenodd",
      opacity: 1
    },
    transform: " translate(-17.5, -6.5)",
    d: "M 17.5 4 C 16.1193 4 15 5.11929 15 6.5 C 15 7.88071 16.1193 9 17.5 9 C 18.8807 9 20 7.88071 20 6.5 C 20 5.11929 18.8807 4 17.5 4 Z M 13 6.5 C 13 4.01472 15.0147 2 17.5 2 C 19.9853 2 22 4.01472 22 6.5 C 22 8.98528 19.9853 11 17.5 11 C 15.0147 11 13 8.98528 13 6.5 Z",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgO);
export default __webpack_public_path__ + "static/media/O.750351dc6cf02f98764848cdea3ce978.svg";
export { ForwardRef as ReactComponent };